export const bhEnv = {
  nodeEnv: process.env.NODE_ENV!,
  sentry: {
    env: process.env.NEXT_PUBLIC_SENTRY_ENV!,
    sampleRate: process.env.NEXT_PUBLIC_SENTRY_SAMPLE_RATE!,
  },
  backendUrl: process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL!,
  bhQuoteApiPath: process.env.NEXT_PUBLIC_BH_QUOTE_API_PATH!,
  bhStoreApiPath: process.env.NEXT_PUBLIC_BH_STORE_API_PATH!,
  companyInfo: {
    name: process.env.NEXT_PUBLIC_COMPANY_NAME!,
    addressLine1: process.env.NEXT_PUBLIC_COMPANY_ADDRESS_LINE_1!,
    addressLine2: process.env.NEXT_PUBLIC_COMPANY_ADDRESS_LINE_2!,
    phone: process.env.NEXT_PUBLIC_COMPANY_PHONE!,
    email: process.env.NEXT_PUBLIC_COMPANY_EMAIL!,
    facebook: process.env.NEXT_PUBLIC_FACEBOOK!,
    linkedin: process.env.NEXT_PUBLIC_LINKEDIN!,
  },
  bhMarketingHome: process.env.NEXT_PUBLIC_MARKETING_SITE_URL!,
  ids: {
    tags: {
      store: process.env.NEXT_PUBLIC_MEDUSA_TAG_ID_STORE!,
    },
    productVariants: {
      stormCollars: {
        standard: process.env.NEXT_PUBLIC_STORM_COLLAR_VARIANT_ID_STANDARD!,
        plus: process.env.NEXT_PUBLIC_STORM_COLLAR_VARIANT_ID_PLUS!,
      },
    },
    products: {
      chaseCover: process.env.NEXT_PUBLIC_CHASE_COVER_PRODUCT_ID!,
      topMount: process.env.NEXT_PUBLIC_TOP_MOUNT_PRODUCT_ID!,
      outsideMount: process.env.NEXT_PUBLIC_OUTSIDE_MOUNT_PRODUCT_ID!,
    },
    shippingOptions: {
      freeRegionalShipping:
        process.env.NEXT_PUBLIC_SHIPPING_OPTION_ID_FREE_REGIONAL_SHIPPING!,
      tbdCall: process.env.NEXT_PUBLIC_SHIPPING_OPTION_ID_TBD_CALL!,
    },
  },
}
